import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";

interface Props {
  modelValue?: string;
  label?: string;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  errorMessage?: string;
  isError?: boolean;
}
interface Emits {
  (e: "update:modelValue", value: string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppTextField',
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: false },
    errorMessage: { default: "" },
    isError: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emits = __emit;

const hasValidationError = computed<boolean>(
  () => props.isError || !!props.errorMessage
);
const localModelValue = ref<string>(props.modelValue);
const showPass = ref<boolean>(false);

const onInput = () => {
  emits("update:modelValue", localModelValue.value);
};

const onShowPass = (): void => {
  showPass.value = !showPass.value;
};

watch(
  () => props.modelValue,
  (newV) => {
    localModelValue.value = newV;
  }
);

const __returned__ = { props, emits, hasValidationError, localModelValue, showPass, onInput, onShowPass, computed, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})